import { Box, Heading, Icon, Paragraph, Tag } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled, IconLightningFilled } from '@zillow/constellation-icons';
import { TourConfirmationType } from '@zg-rentals/ts-z-calendar-client';

import { TOUR_CONFIRMATION_TYPE_LAYOUT, type TOUR_OPTION } from '../../constants/TourCalendar';

type TourConfirmationTypeCardProps = {
  layout: TOUR_CONFIRMATION_TYPE_LAYOUT;
  tourConfirmationType?: TourConfirmationType;
  tourOption: TOUR_OPTION;
};

const TourConfirmationTypeCard = ({ layout, tourConfirmationType, tourOption }: TourConfirmationTypeCardProps) => {
  const isTourOptionSelected = tourOption.id === tourConfirmationType;
  const tourIcon =
    tourOption.id === TourConfirmationType.INSTANT ? <IconLightningFilled /> : <IconCheckmarkCircleFilled />;

  if (layout === TOUR_CONFIRMATION_TYPE_LAYOUT.HORIZONTAL) {
    return (
      <Box css={{ display: 'flex', flexDirection: 'row', gap: 'sm' }}>
        <Icon css={{ color: isTourOptionSelected ? 'brand' : 'textMedium' }} size="md">
          {tourIcon}
        </Icon>

        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'xs' }}>
          <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Heading level={6}>{tourOption.title}</Heading>
            <Tag size="sm">{tourOption.subTitle}</Tag>
          </Box>
          <Paragraph color="text.subtle" textStyle="body-sm">
            {tourOption.description}
          </Paragraph>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'md',
        marginTop: 'xs',
        marginBottom: 'lg',
      }}
    >
      <Icon css={{ color: isTourOptionSelected ? 'brand' : 'textMedium' }} size="lg">
        {tourIcon}
      </Icon>

      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'sm' }}>
        <Heading level={5}>{tourOption.title}</Heading>
        <Tag>{tourOption.subTitle}</Tag>
      </Box>
      <Paragraph
        color="text.subtle"
        textStyle="body-sm"
        css={{ marginLeft: 'tighter', marginRight: 'tighter', textAlign: 'center' }}
      >
        {tourOption.description}
      </Paragraph>
    </Box>
  );
};

export default TourConfirmationTypeCard;
